import React, { Component } from 'react';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup';

// const code = `function add(a, b) {
// //   return a + b;
// // }
// // `;

class EditorCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      // ttid2: "TTID" + String(Math.round(Math.random() * 1000000000)),
      code: ``
    };
  }

  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;
    if (
      pageData && !fileFolder.isOpen &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      defaultValue
    ) {
      this.props.liftState(this.props.component, defaultValue);
    }
  }
  generateID() {
    return this.state.ttid;
  }
  generateID2() {
    return this.state.ttid2;
  }

  handleChange = (e) => {
    this.props.liftState(this.props.component, e);
    this.setState({ code: e })
  }


  render() {
    let { conditionalRender } = this.props;
    const { name, label, placeHolder, description, isReadOnly, style } = this.props.component;
    let { currentPage, formElements, formState, fileFolder, openmodals, pageData, errorMessages } = this.props.parentState;
    let isReadOnly1 = false;
    if ((formState != 'edit' && fileFolder.isOpen) || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit' && fileFolder.isOpen) || conditionalRender == 'readonly') {
      isReadOnly1 = true;
    }
    let boxvalue;
    let { code } = this.state
    let modalname = openmodals[openmodals.length - 1];
    if (modalname && pageData[modalname]) {
      boxvalue = pageData[modalname][name]
        ? pageData[modalname][name]
        : "";
    } else {
      boxvalue = pageData[name]
        ? pageData[name]
        : "";
    }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    let currentError;
    if (errorMessages) {
      if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
        currentError = errorMessages[modalname][name];
      } else if (!modalname && errorMessages[name]) {
        currentError = errorMessages[name];
      }
    }

    // console.log({boxvalue})

    return (
      <div style={{ border: "1px solid green", paddingTop: 10, paddingBottom: 10 }} className={`form-group   ${this.props.component.widths.parent}`}>
        {label &&
          label != "" && (
            <span>
              <label

                className="col-form-label col-form-label-sm nopadding"
              >
                {label}
              </label>

            </span>
          )}
        {" " + this.props.parentState.errorMessages != undefined &&
          this.props.parentState.errorMessages[name] ? (
          <span>

          </span>
        ) : (
          ""
        )}

        <Editor
          value={boxvalue}
          onValueChange={e => this.props.liftState(this.props.component, e)}
          highlight={e => highlight(e, languages.js)}
          name={name}
          padding={10}
          style={{
            fontFamily: '"Fira code", "Fira Mono", monospace',
            fontSize: 12,
            // color: "white",
            // backgroundColor: "black"
          }}
        />


      </div>
    );
  }
}

export default EditorCustom;